"use client";
// React imports
import React from "react";
// Material UI imports
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography, IconButton } from "@mui/material";
// context imports
import { useTheme } from "@/context";
// styles import
import "./modal-header.scss";

type FormHeaderProps = {
    title: string;
    onClose: () => void;
};

const ModalHeader: React.FC<FormHeaderProps> = ({ title, onClose }) => {
    const { darkMode } = useTheme();
    const darkModeClass = darkMode ? "dark" : "light";
    const titleStyles = {
        fontFamily: "Cerebri Sans",
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "25.4px",
        align: "center",
        color: darkMode ? "#F8F8F2" : "#2C2C2C",
    };

    return (
        <Box className={`modal-header ${darkModeClass}`}>
            <Typography
                variant="h6"
                sx={titleStyles}
            >
                {title}
            </Typography>
            <IconButton onClick={onClose}>
                <CloseIcon className="close-icon" />
            </IconButton>
        </Box>
    );
};

export default ModalHeader;